export const ApiKey = '"Secret" key';